<template>
  <div class="d-flex flex-column flex-start align-start">
    <FieldLabel :text="title" />
    <div v-if="items.length">
      <v-chip
        v-for="item in items"
        outlined
        small
        class="mt-1 me-1"
        :key="item"
      >
        {{ $t(`${translationKey}.${item}`) }}
      </v-chip>
    </div>
    <div v-else>
      <p v-if="isImpactValidated" class="text-body-1 ma-0 pa-0">
        -
      </p>
      <v-chip v-else small disabled class="label mt-2">{{
        $t('common.in_progress_status')
      }}</v-chip>
    </div>
  </div>
</template>
<script>
import FieldLabel from '@/components/Core/FieldLabel'

export default {
  name: 'ChipsList',

  components: {
    FieldLabel,
  },

  props: {
    title: { required: true, type: String },
    items: { type: Array, default: () => [] },
    translationKey: { required: true, type: String },
    isImpactValidated: { type: Boolean },
  },
}
</script>
